export const dontNeedServices = `I don't need any services (skip)`;
export const dontNeedUpgrades = `I don't need any upgrades`;
export const next = `next`;
export const enterThePropertyLocation = `Enter the property location`;
export const closePrompt = 'You are currently booking, are you sure you want to leave this page?';
